import script from "./CommentWriter.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommentWriter.vue?vue&type=script&lang=ts&setup=true"

import "./CommentWriter.vue?vue&type=style&index=0&id=da683dd2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da683dd2"]])

export default __exports__